import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const TerminosYPoliticas = (props) => {
  const { terminos, setTerminos, setPoliticas, politicas } = props;
  return (
    <Fragment>
      <h4 style={{ marginTop: "40px" }}>t&eacute;rminos y condiciones</h4>
      <ul>
        <li>
          <input
            className="styled-checkbox"
            name="terminos"
            id="tos-contratacion"
            onChange={() => setTerminos(!terminos)}
            type="checkbox"
            value="He leido, comprendido y Acepto los T&eacute;rminos y Condiciones de Contrataci&oacute;n"
          />
          <label htmlFor="tos-contratacion">
            He leido, comprendido y Acepto los{" "}
            <Link to="/terminos-y-condiciones" target="_blank">
              Condiciones de contrataci&oacute;n
            </Link>
          </label>
        </li>
        {setPoliticas && (
          <li>
            <input
              className="styled-checkbox"
              name="politicas"
              id="tos-traslado"
              onChange={() => setPoliticas(!politicas)}
              type="checkbox"
              value="He leido, comprendido y Acepto las Pol&iacute;ticas de traslado de menores"
            />
            <label htmlFor="tos-traslado">
              He leido, comprendido y Acepto las{" "}
              <a
                href="http://www.migraciones.gov.ar/site_docs/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pol&iacute;ticas de traslado de menores
              </a>
            </label>
          </li>
        )}
      </ul>
    </Fragment>
  );
};

export default TerminosYPoliticas;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/terminosYpoliticas.js